var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteMotoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 12c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 5.714c-.945 0-1.714-.769-1.714-1.714s.769-1.714 1.714-1.714 1.714.769 1.714 1.714-.769 1.714-1.714 1.714zM9.758 14.4c-.08-.24-.296-.4-.539-.4H6c.946 0 1.715.808 1.715 1.8S6.945 17.6 6 17.6s-1.714-.808-1.714-1.8S5.055 14 6 14H2.782c-.243 0-.459.16-.539.4-.164.484-.243.942-.243 1.4C2 18.116 3.794 20 6 20s4-1.884 4-4.2c0-.458-.079-.916-.242-1.4zM12.2 6H3.8C2.808 6 2 6.673 2 7.5S2.808 9 3.8 9h8.4c.992 0 1.8-.673 1.8-1.5S13.192 6 12.2 6zM17.649 7.044c-.29-.12-.626.016-.748.307l-2.857 6.857c-.121.291.016.626.307.747.072.031.147.045.22.045.224 0 .435-.133.528-.352l2.857-6.857c.121-.291-.016-.626-.307-.747z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.864 10.945c-.11-.12-.271-.189-.442-.189H4.046c-.672 0-1.31-.218-1.846-.632-.235-.18-.583-.162-.793.043-.11.106-.213.215-.309.322C.39 11.289 0 12.325 0 13.409 0 14.286.778 15 1.734 15h9.248c.301 0 .552-.211.576-.486.001-.017.157-1.689.434-3.136.028-.154-.018-.313-.128-.433zM19.917 1.312c-.673.1-1.075.617-.858 1.102l.003.005c.154.347.59.581 1.08.581h1.188L22 1l-2.083.312z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.83 1.155c-.148-.124-.363-.18-.569-.145l-1.922.31c-.469.077-.875.313-1.115.648s-.29.737-.137 1.109c.227.552.863.923 1.582.923h1.096c.283 0 .53-.156.599-.379l.617-2c.052-.166-.006-.342-.152-.466zM20.282 3h-.614c-.186 0-.352-.097-.412-.245-.055-.13-.001-.235.036-.286.035-.051.122-.141.289-.168l.964-.156-.263.855z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.071 9.367c-1.213 0-1.698-1.268-1.73-1.35l-2.965-6.946C19.034.269 18.178-.157 17.33.053c-.473.118-.88.434-1.114.863-.235.43-.282.943-.127 1.409l.56 1.688 1.536-.925c.267-.16.61-.074.77.192.16.267.073.613-.192.773l-1.75 1.054.912 2.746c.022.063.053.122.094.174l1.005 1.263c.488.61.5 1.46.032 2.068-.318.411-.574.837-.762 1.265-.23.524-.182 1.125.13 1.606.314.483.843.771 1.414.771h.865c.31 0 .56-.252.56-.563 0-.117-.042-.218-.102-.307l2.45-1.64c.098.147.254.252.443.257 1.132.035 3.121 0 3.7-.564.159-.155.245-.355.245-.563 0-1.16-2.214-2.253-3.929-2.253z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.919 2.291c-.163-.283-.512-.377-.785-.205l-2.857 1.8c-.27.17-.358.538-.196.822.108.189.296.292.49.292.101 0 .203-.028.295-.086l2.857-1.8c.27-.17.358-.54.196-.823zM14.444 14h-3.888c-.307 0-.556.224-.556.5s.249.5.556.5h3.888c.307 0 .556-.224.556-.5s-.249-.5-.556-.5z",
    transform: "translate(0 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteMotoWhite);
export default __webpack_public_path__ + "static/media/transporte-moto-white.fc39cb15.svg";
export { ForwardRef as ReactComponent };